import * as t from "io-ts"

const OrganisationDetails = t.type({
    organisationId: t.string,
    organisationName: t.string,
    organisationType: t.string,
    organisationAddress: t.union([t.string, t.null]),
    organisationPostcode: t.union([t.string, t.null]),
    organisationContactNumber: t.union([t.string, t.null]),
})

export const OrganisationsDetails = t.array(OrganisationDetails)

export type IOrganisationDetails = t.TypeOf<typeof OrganisationsDetails>
